import { Injectable } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class FiltreUtilsService {

	constructor(private translateService: TranslateService) {
	}

	/**
	 * Construit un filtre avec les valeurs oui / non et tous
	 */
	construireFiltreOuiNonTous(): Observable<SelectItem[]> {
		const filtre: SelectItem[] = [];
		const filtreSubject = new ReplaySubject<SelectItem[]>();

		this.translateService.get([
			'GLOBAL.FILTRES.TOUS',
			'GLOBAL.FILTRES.OUI',
			'GLOBAL.FILTRES.NON'
		]).subscribe(traductions => {
			filtre.push({
				label: traductions['GLOBAL.FILTRES.TOUS'],
				value: [true, false]
			});
			filtre.push({
				label: traductions['GLOBAL.FILTRES.OUI'],
				value: [true]
			});
			filtre.push({
				label: traductions['GLOBAL.FILTRES.NON'],
				value: [false]
			});
			filtreSubject.next(filtre);
		});

		return filtreSubject;
	}
}
